<template>
  <div>
  <Card>
      <Row>
        <i-col span="24">
          <Form ref="searchForm" inline :model="searchForm" :label-width="60" @submit.native.prevent>
            <FormItem label="主机名" prop="name">
              <i-input v-model="searchForm.name" placeholder="请输入主机"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getAgentLogList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
       </Row>
      <tables search-place="top" v-model="tableData" :columns="columns" @on-sort-change="changeSort"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getAgentLogList"></page>
        </div>
     </Row>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getAgentLogs } from '@/api/opscenter'
import moment from 'moment'
export default {
  name: 'AgentLogs',
  props: ['ip'],
  components: {
    Tables
  },
  data () {
    return {
      count: 1,
      size: 10,
      page: 1,
      change: false,
      ordering: null,
      columns: [
        { title: 'ID', key: 'id', align: 'center', sortable: 'custom', minWidth: 70 },
        { title: '任务名称', key: 'name', align: 'center', minWidth: 120 },
        { title: '主机', key: 'server', align: 'center', minWidth: 100 },
        {
          title: '系统',
          key: 'os_type',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            const row = params.row
            const text = row.os_type === '0' ? 'Linux' : 'Windows'
            return h('span', {
            }, text)
          }
        },
        { title: '执行用户', key: 'user', align: 'center', minWidth: 100 },
        {
          title: '执行时间',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            if (params.row.datetime) {
              return h('div', moment(params.row.datetime).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },
        {
          title: '执行结果',
          key: 'status',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            const row = params.row
            const color = row.status === '0' ? 'success' : 'error'
            const text = row.status === '0' ? '完成' : '错误'
            return h('Tag', {
              props: {
                type: 'dot',
                color: color
              }
            }, text)
          }
        },
        {
          title: '操作',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small',
                    title: '结果详情'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.handleRender(params)
                    }
                  }
                }, '结果详情')
              ])
            } else {}
          }
        }
      ],
      tableData: [],
      user_all: [],
      searchForm: {
        name: null
      },
      listStyle: {
        width: '250px',
        height: '300px'
      }
    }
  },
  watch: {
  },
  methods: {
    getAgentLogList (value = 1) {
      this.page = value
      let params = {
        page: this.page,
        ordering: this.ordering,
        search: this.searchForm.name
      }
      getAgentLogs(params).then(res => {
        this.tableData = res.data.results
        this.count = res.data.count
      })
    },
    changeSort (column) {
      if (column.key === 'id') {
        if (column.order === 'asc') {
          this.ordering = 'id'
        } else {
          this.ordering = '-id'
        }
      }
      this.getAgentLogList()
    },
    searchReset () {
      this.searchForm.name = null
    },
    handleRender (params) {
      this.$Modal.info({
        width: '750px',
        title: '日志详情',
        render: (h) => {
          // let jsonData = JSON.stringify(params.row.result, null, 4)
          return h('div', [
            // h('span', {}, params.row.result | json)
            h('pre', {
              props: {
                autosize: { minRows: 6, maxRows: 20 }
              },
              style: {
                'white-space': 'pre-wrap',
                'overflow': 'auto',
                width: '98%',
                height: '450px'
              }
            }, params.row.result)
            // h('Input', {
            //   props: {
            //     type: 'textarea',
            //     value: params.row.result,
            //     autofocus: true,
            //     placeholder: '',
            //     readonly: true,
            //     autosize: { minRows: 6, maxRows: 20 }
            //   },
            //   style: {
            //     width: '98%',
            //     height: '450px'
            //   }
            // })
          ])
        }
      })
    }
  },
  mounted: function () {
    this.getAgentLogList()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
.ivu-input[disabled], fieldset[disabled] .ivu-input {
    background-color: #f3f3f3;
    opacity: 1;
    cursor: not-allowed;
    color: #666;
}
</style>
